(function (root) {
  const normalize = value => String(value || '').normalize('NFC').trim();
  function findVariant(product, sku) {
    if (!normalize(sku)) return null;
    return (product?.variants || []).find(variant => normalize(variant.sku) === normalize(sku)) || null;
  }
  function createSelectionLoader(fetchProduct, { maxAge = Infinity } = {}) {
    const cache = new Map();
    let sequence = 0;
    return async (handle, sku, paint, { force = false } = {}) => {
      const request = ++sequence;
      let entry;
      try {
        entry = cache.get(handle);
        if (force || !entry || Date.now() - entry.created >= maxAge) {
          entry = { created: Date.now(), promise: fetchProduct(handle) };
          cache.set(handle, entry);
        }
        const product = await entry.promise;
        if (request !== sequence) return;
        const variant = findVariant(product, sku);
        paint({ status: variant ? 'verified' : 'unknown', product, variant });
      } catch (error) {
        if (cache.get(handle) === entry) cache.delete(handle);
        if (request === sequence) paint({ status: 'unknown', error });
      }
    };
  }
  const api = { findVariant, createSelectionLoader };
  if (typeof module !== 'undefined') module.exports = api;
  else root.MarbilyCommerce = api;
})(typeof window !== 'undefined' ? window : globalThis);
